<!--suppress ALL -->
<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 mb-4">
                <StepProgress :wizardSection="realEstate.wizardSection" :realEstate="realEstate"></StepProgress>
            </div>
            <div class="col-12">
                <div class="card card-form">
                    <div class="card-header">
                        <div class="row">
                            <div class="col">
                                <div class="pull-left">
                                    <h4 class="card-title float-left" v-if="realEstate.id">
                                        {{$t("realEstate.edit.title")}}
                                        ({{$t(realEstate.category === 'Residential' ?
                                        'realEstate.category.residential.label' :
                                        'realEstate.category.notorious.label')}})</h4>
                                    <h4 class="card-title float-left" v-else>{{$t("realEstate.add.title")}}
                                        ({{$t(realEstate.category === 'Residential' ?
                                        'realEstate.category.residential.label' :
                                        'realEstate.category.notorious.label')}})</h4>
                                </div>
                                <button class="all-btn btn-sm pull-right mr-3"
                                        v-if="realEstate.landComparisonEnabled"
                                        @click="headerAction('new_land')"
                                >
                                    Янги ер участкаси калкуляцияси
                                </button>
                            </div>
                        </div>
                        <div class="row" v-if="realEstate.status === 'Rejected'">
                            <div class="col">
                                <div class="alert alert-danger">
                                    <strong>Бекор қилинган!</strong> Баҳолаш жараёни бекор қилинган..
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <div class="row">
                                        <div class="col-12">
                                            <label>{{$t("realEstate.field.approachMethods")}} <span class="red">*</span></label>
                                        </div>
                                        <div class="col-12">
                                            <div :class="{invalid : $v.realEstate.approach.$error}">
                                                <div class="form-check pl-0 checkbox-inline">
                                                    <label class="form-check-label"
                                                           style="padding-left:22px !important">
                                                        <input class="form-check-input" type="checkbox"
                                                               v-model="realEstate.approachCost"
                                                        >
                                                        <span class="form-check-sign"></span>
                                                        {{$t("realEstate.approach.expense")}}
                                                    </label>
                                                </div>
                                                <div class="form-check checkbox-inline">
                                                    <label class="form-check-label">
                                                        <input class="form-check-input" type="checkbox"
                                                               v-model="realEstate.approachIncome"
                                                               :disabled="isNoChangeIncome"
                                                        >
                                                        <span class="form-check-sign"></span>
                                                        {{$t("realEstate.approach.income")}}
                                                    </label>
                                                </div>
                                                <div class="form-check checkbox-inline">
                                                    <label class="form-check-label">
                                                        <input class="form-check-input" type="checkbox"
                                                               v-model="realEstate.approachComparative"
                                                        >
                                                        <span class="form-check-sign"></span>
                                                        {{$t("realEstate.approach.comparative")}}
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="red" v-if="$v.realEstate.approach.$error">
                                                {{$t("realEstate.validation.approachMethods")}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.name")}} <span class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="realEstate.name"
                                           :class="{invalid : $v.realEstate.name.$error}"/>
                                    <div class="red" v-if="$v.realEstate.name.$error">
                                        {{$t("realEstate.validation.name")}}
                                    </div>
                                </div>
                                <label>{{$t("realEstate.field.cadastreNumber")}} <span class="red">*(Кадастр маълумотларини олиш учун кнопкани босинг!)</span></label>
                                <div class="input-group mb-2">
                                    <cadastre-input :cadastre-number.sync="realEstate.cadastreDocNumber" :invalid="$v.realEstate.cadastreDocNumber.$error"/>
                                    <div class="input-group-append">
                                        <button class="all-btn search-btn" type="button"
                                                :disabled="realEstate.wizardSection > 1 || !hasPermission('NEW_REAL_ESTATE_CADASTER_API') || loadCadastreDoc"
                                                @click="initCadastreApiData"
                                        >Маълумотни олиш</button>
                                    </div>
                                </div>
                                <div class="red" v-if="$v.realEstate.cadastreDocNumber.$error">
                                    {{$t("realEstate.validation.cadastreNumber")}}
                                </div>
                                <div :class="{invalid: $v.specialComfort.code.$error}">
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.specialComfort")}} <span class="red">*</span></label>
                                        <v-select v-model="specialComfort" label="displayName"
                                                  :options="specialComforts"
                                                  :filterable="false"
                                                  @search:focus="onSpecialComfortFocus"
                                        >
                                            <template slot="option" slot-scope="option" v-if="option && option.displayName">
                                                <div v-html="option.displayName"></div>
                                            </template>
                                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                        </v-select>
                                    </div>
                                </div>
                                <div :class="{invalid: $v.architecturalStyle.code.$error}">
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.architecturalStyle")}} <span class="red">*</span></label>
                                        <v-select v-model="architecturalStyle" label="displayName"
                                                  :options="architecturalStyles"
                                                  :filterable="false"
                                                  @search:focus="onArchitecturalStyleFocus"
                                        >
                                            <template slot="option" slot-scope="option" v-if="option && option.displayName">
                                                <div v-html="option.displayName"></div>
                                            </template>
                                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                        </v-select>
                                    </div>
                                </div>
                                <div class="red" v-if="$v.architecturalStyle.code.$error">{{$t('newRealEstate.validation.repairCondition')}}</div>
                                <div :class="{invalid : $v.realEstate.sections.$error}">
                                    <div class="form-group" v-if="realEstate.approachCost">
                                        <label>{{$t("realEstate.field.cadastreSection")}} <span class="red">*</span></label>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <treeselect class="form-control" v-model="realEstate.cadastreSections"
                                                            placeholder="Танланг..."
                                                            :options="cadastreSections"
                                                            :multiple="true"
                                                            >
                                                </treeselect>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="red" v-if="$v.realEstate.sections.$error">
                                    {{$t("realEstate.validation.cadastreSection")}}
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                               <div :class="{invalid: $v.buildingType.code.$error}">
                                   <div class="form-group">
                                       <label>{{$t("realEstate.field.buildingType")}} <span class="red">*</span></label>
                                       <v-select v-model="buildingType" label="name"
                                                 :options="buildingTypes"
                                                 :filterable="false"
                                                 @search:focus="onBuildingFocus"
                                                 @change="onChangeBuildingType"
                                       >
                                           <template slot="option" slot-scope="option" v-if="option && option.name">
                                               <div v-html="option.name"></div>
                                           </template>
                                           <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                       </v-select>
                                   </div>
                               </div>
                                <div class="red" v-if="$v.buildingType.code.$error">{{$t('newRealEstate.validation.buildingType')}}</div>
                                <div :class="{invalid: $v.repairCondition.code.$error}">
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.repairConditions")}} <span class="red">*</span></label>
                                        <v-select v-model="repairCondition" label="displayName"
                                                  :options="repairConditions"
                                                  :filterable="false"
                                                  @search:focus="onRepairFocus"
                                                  @change="onRepairChange"
                                        >
                                            <template slot="option" slot-scope="option" v-if="option && option.displayName">
                                                <div v-html="option.displayName"></div>
                                            </template>
                                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                        </v-select>
                                    </div>
                                </div>
                                <div class="red" v-if="$v.repairCondition.code.$error">{{$t('newRealEstate.validation.repairCondition')}}</div>
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.constructionCompletion")}} <span class="red">*</span></label>
                                    <numeric-input v-model="realEstate.constructionCompletion" :max="100" :precision="2" @change="onChangeConstructionCompletion"></numeric-input>
                                    <div class="red" v-if="$v.realEstate.constructionCompletion.$error">{{$t("newRealEstate.validation.constructionCompletion")}}</div>
                                </div>
                                <div class="form-group">
                                    <div class="form-check checkbox-inline">
                                        <label class="form-check-label pl-0">
                                            <input class="form-check-input" type="checkbox"
                                                   v-model="realEstate.lightConstructiveElement"
                                                   :disabled="!hasPermission('REAL_ESTATE_LIGHT_CONSTRUCTIVE_ELEMENT')"
                                                   name="contractAmountByAgreement">
                                            <span class="form-check-sign"></span>
                                            Енгил конструктив элемент
                                        </label>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.evaluatorIdea")}}</label>
                                    <textarea type="text" class="form-control"
                                              v-model="realEstate.evaluatorIdea"></textarea>
                                </div>
                            </div>
                        </div>
                        <div role="tablist">
                            <div class="row mt-4">
                                <div class="col-12">
                                    <div class="section-header font-weight-bold" style="cursor: pointer;">
                                        <div block v-b-toggle.header-1 v-tooltip="'Кўчмас мулк асосий маълумотлари очиш'">
                                            <h4>
                                                <i class="fa fa-arrow-down"></i>
                                                {{$t("realEstate.field.basicInformation")}}
                                            </h4>
                                        </div>
                                    </div>
                                    <b-collapse id="header-1" accordion="evl-accordion" role="tabpanel" v-model="realEstateVisible">
                                        <div class="row">
                                            <div class="col-12 col-md-6">
                                                <div class="form-group">
                                                    <label>Кадастр ёки баланс қиймати <span class="red">*</span></label>
                                                    <numeric-input
                                                            v-model="realEstate.cadastreBalance"
                                                            :precision="2" align="right"
                                                            :class="{invalid : $v.realEstate.cadastreBalance.$error}"
                                                    ></numeric-input>
                                                    <div class="red" v-if="$v.realEstate.cadastreBalance.$error">{{$t("building.validation.cadastreBalance")}}</div>
                                                </div>
                                                <div class="form-group" v-if="(microRegions && microRegions.length > 0)">
                                                    <label>{{$t("realEstate.field.microRegion")}} <span class="red">*</span></label>
                                                    <select class="form-control"
                                                            v-model="realEstate.microRegionId"
                                                            :class="{invalid: $v.realEstate.microRegionId.$error}"
                                                    >
                                                        <option value=""></option>
                                                        <option :value="option.id" v-for="option in microRegions" :key="option.id">
                                                            {{option.name}}
                                                        </option>
                                                    </select>
                                                </div>
                                                <div class="form-group">
                                                    <label>{{$t("realEstate.field.addressAddEdit")}} <span class="red">*</span></label>
                                                    <input type="text" class="form-control" v-model="realEstate.address"
                                                           :class="{invalid : $v.realEstate.address.$error}"/>
                                                    <div class="red" v-if="$v.realEstate.address.$error">
                                                        {{$t("realEstate.validation.addressAddEdit")}}
                                                    </div>
                                                </div>
                                                <div class="border border-gray">
                                                    <div class="form-group">
                                                        <label class="ml-2">{{$t("realEstate.field.letterNumberText")}}
                                                            <span class="text-dark">{{realEstate.contractNumber}}</span>
                                                        </label>
                                                    </div>
                                                    <div class="form-group">
                                                        <label class="ml-2">{{$t("realEstate.field.invoiceNumberText")}}
                                                            <span class="text-dark">{{realEstate.contractNumberText}}</span>
                                                        </label>
                                                    </div>
                                                    <div class="form-group">
                                                        <label class="ml-2">{{$t("realEstate.field.reportNumberText")}}
                                                            <span v-if="showReportButton" class="text-dark">{{realEstate.reportNumberText}}</span>
                                                        </label>
                                                    </div>
                                                </div>
                                                <div class="form-group">
                                                    <label class="mt-4">{{$t("realEstate.field.locationText")}}</label>
                                                    <real-estate-location-map :dataSource="realEstate.target" :marker="false" :height="320"/>
                                                </div>
                                              <div :class="{invalid: $v.wall.code.$error}">
                                                <div class="form-group">
                                                  <label>{{$t("realEstate.field.constructiveElement")}} <span class="red">*</span></label>
                                                  <v-select v-model="wall" label="displayName"
                                                            :options="walls"
                                                            :filterable="false"
                                                            @search:focus="onConstructiveElementFocus"
                                                  >
                                                    <template slot="option" slot-scope="option" v-if="option && option.displayName">
                                                      <div v-html="option.displayName"></div>
                                                    </template>
                                                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                                  </v-select>
                                                </div>
                                              </div>
                                              <div class="red" v-if="$v.wall.code.$error">{{$t('newRealEstate.validation.wall')}}</div>
                                              <div class="form-group" v-if="!isBuildingMultiStorey">
                                                <div class="form-check pl-0">
                                                  <label class="form-check-label" style="padding-left:22px !important">
                                                    <input type="checkbox"
                                                           class="form-check-input"
                                                           v-model="realEstate.separateBuilding"
                                                    >
                                                    <span class="form-check-sign"></span>
                                                    {{$t("realEstate.field.separateBuilding")}}
                                                  </label>
                                                </div>
                                              </div>

                                              <div class="form-group">
                                                <label>{{$t('realEstate.field.storey')}}</label>
                                                <select class="form-control"
                                                        v-model="realEstate.storey"
                                                        @input="onChangeStorey"
                                                        :class="{invalid: $v.realEstate.storey.$error}"
                                                >
                                                  <option :value="option.value"
                                                          v-for="option in ref.storeys"
                                                          :key="option.label">{{option.label}}
                                                  </option>
                                                </select>
                                                <!-- <numeric-input v-model="realEstate.storey" :precision="0"
                                                                :formatType="'String'"
                                                                :class="{invalid: $v.realEstate.storey.$error}"
                                                                @input="onChangeStorey"
                                                 ></numeric-input> -->
                                              </div>
                                              <div class="form-group" v-if="!isSeparateBuilding">
                                                <label>{{$t('realEstate.field.floor')}}</label>
                                                <select class="form-control"
                                                        v-model="realEstate.floor"
                                                        :class="{invalid: $v.realEstate.floor.$error}"
                                                >
                                                  <option :value="option.value"
                                                          v-for="option in ref.floors"
                                                          :key="option.label">{{option.label}}
                                                  </option>
                                                </select>
                                                <!-- <numeric-input v-model="realEstate.floor" :precision="0"
                                                               :formatType="'String'"
                                                               :class="{invalid: $v.realEstate.floor.$error}"
                                                ></numeric-input> -->
                                              </div>

                                              <div class="form-group">
                                                <label>{{$t('realEstate.field.builtYear')}}</label>
                                                <numeric-input
                                                    v-model="realEstate.builtYear"
                                                    :precision="0"
                                                    :max="maxMadeYear"
                                                    :class="{invalid: $v.realEstate.builtYear.$error}"
                                                >
                                                </numeric-input>
                                              </div>
                                            </div>
                                            <div class="col-12 col-md-6">
                                                <div class="form-group">
                                                    <label>{{$t("realEstate.field.areaTotal")}} <span class="red">*</span></label>
                                                    <numeric-input v-model="realEstate.evlGroundArea" :precision="2"></numeric-input>
                                                </div>
                                                <div class="form-group">
                                                    <label>{{$t("realEstate.field.areaUnderConstruction")}} <span
                                                            class="red">*</span></label>
                                                    <numeric-input v-model="realEstate.evlBuildingWidthArea"
                                                                   :precision="2"
                                                                   :class="{invalid : $v.realEstate.evlBuildingWidthArea.$error}"
                                                    ></numeric-input>
                                                    <div class="red" v-if="$v.realEstate.evlBuildingWidthArea.$error">
                                                        {{$t("realEstate.validation.areaUnderConstruction")}}
                                                    </div>
                                                </div>
                                                <div class="form-group">
                                                    <label>{{$t("realEstate.field.areaUseful")}} <span class="red">*</span></label>
                                                    <numeric-input v-model="realEstate.evlUsefulField" :precision="2"
                                                                   :class="{invalid : $v.realEstate.evlUsefulField.$error}"
                                                                   @input="onChangeUsefulArea"
                                                    ></numeric-input>
                                                    <div class="red" v-if="$v.realEstate.evlUsefulField.$error">
                                                        {{$t("realEstate.validation.areaUseful")}}
                                                    </div>
                                                    <div class="red" v-if="$v.usefulAreaValid.$error">
                                                        {{$t("newRealEstate.validation.usefulAreaValid")}}
                                                    </div>
                                                </div>

                                                <template v-for="(field,index) in cadastreBuildingFields">
                                                    <div class="form-group" :key="field.code" v-if="field.code !== 'non_market_type'">
                                                        <label v-if="hasBasementField(field.code)">
                                                            <div v-if="field.code=='housing_type'">
                                                                {{$t(realEstate.category === 'Residential' ?
                                                                'realEstate.category.residential.label' :
                                                                'realEstate.category.notorious.label')}} {{$t('realEstate.field.housingType')}}
                                                            </div>
                                                            <div v-else>{{field.name}} <span class="red">*</span></div>
                                                        </label>
                                                        <template v-if="field.type === 'DECIMAL'">
                                                            <numeric-input v-model="field.value2" :precision="2"
                                                                           :class="{invalid : $v.cadastreBuildingFields.$each[index].value2.$error}"
                                                                           @change="onFieldValueChange(field)"
                                                            ></numeric-input>
                                                        </template>
                                                        <template v-else-if="field.type === 'LISTBOX' && hasBasementField(field.code)">
                                                            <select class="form-control" v-model="field.value2"
                                                                    :class="{invalid : $v.cadastreBuildingFields.$each[index].value2.$error}"
                                                                    @change="onFieldValueChange(field)">
                                                                <option :value="option.id"
                                                                        v-for="option in cadastreBuildingFieldReferences[field.reference.code]"
                                                                        :key="option.id">{{option.name}}
                                                                </option>
                                                            </select>
                                                        </template>
                                                        <template v-else-if="field.type === 'MULTISELECT'">
                                                            <treeselect class="form-control" v-model="field.selected2"
                                                                        :multiple="true"
                                                                        placeholder="Танланг..."
                                                                        :options="multiSelectOptions(cadastreBuildingFieldReferences[field.reference.code])"
                                                                        @input="onFieldValueChange(field)"
                                                                        :class="{invalid : $v.cadastreBuildingFields.$each[index].value2.$error}"
                                                            >
                                                            </treeselect>
                                                        </template>
                                                    </div>
                                                </template>
                                              <div class="form-group">
                                                <div class="row">
                                                  <div class="col-12">
                                                    <label>{{$t("realEstate.field.valueType")}} <span
                                                        class="red">*</span></label>
                                                  </div>
                                                  <div class="col-12" :class="{invalid : $v.realEstate.evlValueType.$error}">
                                                    <div class="form-check form-check-radio checkbox-inline pl-0"
                                                         style="margin-left:-0.8rem">
                                                      <label class="form-check-label">
                                                        <input class="form-check-input" type="radio" name="evlValueType"
                                                               value="Market" v-model="realEstate.evlValueType">
                                                        <span class="form-check-sign"></span>
                                                        {{$t("realEstate.valueType.market")}}
                                                      </label>
                                                    </div>
                                                    <div class="form-check form-check-radio checkbox-inline">
                                                      <label class="form-check-label">
                                                        <input class="form-check-input" type="radio" name="evlValueType"
                                                               value="NonMarket" v-model="realEstate.evlValueType">
                                                        <span class="form-check-sign"></span>
                                                        {{$t("realEstate.valueType.nonMarket")}}
                                                      </label>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div class="red" v-if="$v.realEstate.evlValueType.$error">
                                                  {{$t("realEstate.validation.valueType")}}
                                                </div>
                                              </div>
                                              <div v-if="realEstate.evlValueType === 'NonMarket'">
                                                <template v-for="(field, index) in cadastreBuildingFields">
                                                  <div class="form-group" :key="field.code" v-if="field.code === 'non_market_type'">
                                                    <label>{{field.name}} <span class="red">*</span></label>
                                                    <select class="form-control" v-model="field.value2"
                                                            :class="{invalid : $v.cadastreBuildingFields.$each[index].value2.$error}"
                                                            @change="onFieldValueChange(field)"
                                                    >
                                                      <option :value="option.id" v-for="option in cadastreBuildingFieldReferences[field.reference.code]" :key="option.id">
                                                        {{option.name}}
                                                      </option>
                                                    </select>
                                                    <div class="red" v-if="$v.cadastreBuildingFields.$each[index].value2.$error">{{$t("building.validation.customFieldSelect", [field.name.toLowerCase()])}}</div>
                                                  </div>
                                                </template>
                                              </div>
                                                <template>
                                                    <div class="form-group">
                                                        <div class="form-check checkbox-inline">
                                                            <label class="form-check-label pl-0">
                                                                <input class="form-check-input" type="checkbox"
                                                                       v-model="realEstate.landComparisonEnabled"
                                                                       name="landComparisonEnabled"
                                                                       @change="handleChangeLand($event)"
                                                                >
                                                                <span class="form-check-sign"></span>
                                                                {{$t("realEstate.field.landComparison")}}
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div class="form-group">
                                                        <div class="form-check checkbox-inline">
                                                            <label class="form-check-label pl-0">
                                                                <input class="form-check-input" type="checkbox"
                                                                       v-model="realEstate.landLeaseEnabled"
                                                                       name="landLeaseEnabled"
                                                                       @change="handleChangeLand($event)"
                                                                >
                                                                <span class="form-check-sign"></span>
                                                                {{$t("realEstate.field.landLeaseEnabled")}}
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div class="form-group">
                                                        <div class="form-check checkbox-inline">
                                                            <label class="form-check-label pl-0">
                                                                <input class="form-check-input" type="checkbox"
                                                                       v-model="realEstate.landOwnerEnabled"
                                                                       name="landOwnerEnabled"
                                                                       @change="handleChangeLand($event)"
                                                                >
                                                                <span class="form-check-sign"></span>
                                                                {{$t("realEstate.field.landOwnerEnabled")}}
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <template v-if="realEstate.landLeaseEnabled && realEstate.landLeaseData">
                                                        <div class="table-responsive mt-3">
                                                            <table class="table table-sm table-striped">
                                                                <thead>
                                                                <th width="20%" class="text-center"><label>Жойлашган жойи</label></th>
                                                                <th width="10%" class="text-center"><label>Зона</label></th>
                                                                <th width="15%" class="text-center"><label>1 кв.м ижара сўммаси</label></th>
                                                                <th width="25%" class="text-center"><label>Ер участкаси майдони кв.м</label></th>
                                                                <th class="text-center"><label>Ер участкаси якуний қиймати (сўм)</label></th>
                                                                </thead>
                                                                <tbody>
                                                                <tr>
                                                                    <td class="text-left">{{realEstate.province.name}}, {{realEstate.region.name}}</td>
                                                                    <td class="text-center">{{realEstate.landLeaseData.zone}}</td>
                                                                    <td class="text-right">{{realEstate.landLeaseData.rentAmount | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                                                    <td class="text-center">{{realEstate.landLeaseData.area}}</td>
                                                                    <td class="text-right">{{realEstate.landLeaseData.calculatedTotalPrice | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                                                </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </template>
                                                    <div class="form-group">
                                                        <div class="form-check checkbox-inline">
                                                            <label class="form-check-label pl-0">
                                                                <input class="form-check-input" type="checkbox"
                                                                       v-model="realEstate.fixByIndex"
                                                                       name="isFixByIndexComparative"
                                                                >
                                                                <span class="form-check-sign"></span>
                                                                {{$t("realEstate.field.isFixByIndexLabel")}}
                                                            </label>
                                                        </div>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </b-collapse>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12" >
                                    <div class="section-header font-weight-bold" style="cursor: pointer;">
                                        <div block v-b-toggle.docsToSubmit>
                                            <h4>
                                                <i class="fa fa-arrow-down"></i>
                                                {{$t("realEstate.field.docsToSubmit")}} <span class="text-danger" v-if="isCollapseVisibleDocs">{{$t("realEstate.validation.realEstateDocs")}}</span>
                                            </h4>
                                        </div>
                                    </div>
                                </div>
                                <b-collapse id="docsToSubmit" accordion="evl-accordion" role="tabpanel">
                                    <template v-if="realEstate.evlGoalType && !isPageLoadInit">
                                        <RealEstateDropZone code="cadastreDropZone" label="realEstate.field.docCadastre"
                                                            folder="Cadastre" :data="realEstate.cadastre"
                                                            @change="(files) => {realEstate.cadastre = files}"
                                                            :has-error="$v.realEstate.cadastre.$error"
                                                            :removeFile="canRemoveFile"
                                                            :editable="canSave"
                                        />

                                        <!--Хусусийлаштириш максадида-->
                                        <template v-if="isOwnerTypeLegal && isPrivatizationSimple">
                                            <RealEstateDropZone code="privatizationLetterDropZone"
                                                                label="realEstate.field.docPrivatizationLetter"
                                                                folder="PrivatizationLetter"
                                                                :data="realEstate.privatizationLetter"
                                                                @change="(files) => {realEstate.privatizationLetter = files}"
                                                                :removeFile="canRemoveFile"
                                                                :editable="canSave"
                                                                :has-error="$v.realEstate.privatizationLetter.$error"/>
                                            <RealEstateDropZone code="privatizationCommissionOrderDropZone"
                                                                label="realEstate.field.docPrivatizationCommissionOrder"
                                                                folder="PrivatizationCommissionOrder"
                                                                :data="realEstate.privatizationCommissionOrder"
                                                                @change="(files) => {realEstate.privatizationCommissionOrder = files}"
                                                                :removeFile="canRemoveFile"
                                                                :editable="canSave"
                                                                :has-error="$v.realEstate.privatizationCommissionOrder.$error"/>
                                            <RealEstateDropZone code="ownershipCertificateDropZone"
                                                                label="realEstate.field.docOwnershipCertificate"
                                                                folder="OwnershipCertificate"
                                                                :data="realEstate.ownershipCertificate"
                                                                @change="(files) => {realEstate.ownershipCertificate = files}"
                                                                :removeFile="canRemoveFile"
                                                                :editable="canSave"
                                                                :has-error="$v.realEstate.ownershipCertificate.$error"/>
                                        </template>
                                    </template>
                                    <template v-if="!isPageLoadInit">
                                        <RealEstateDropZone code="realEstatePhotoDropZone"
                                                            folder="Building"
                                                            label="building.field.photosToSubmit"
                                                            view="BUILDING" :data="realEstate.photos"
                                                            @change="(photos) => {realEstate.photos = photos}"
                                                            :class="'col-md-12'"
                                                            :removeFile="canRemoveFile"
                                                            :editable="canSave"
                                        />
                                    </template>
                                    <div v-if="realEstate.id && realEstate.id > 0">
                                        <template>
                                            <PreviewDropZone code="checkPaymentDropZone" :label="checkPaymentLbl"
                                                             :data="realEstate.checkPaymentFiles"
                                                             @change="(files) => {realEstate.checkPaymentFiles = files}"
                                            />
                                        </template>
                                        <div class="form-check checkbox-inline">
                                            <label class="form-check-label pl-3 font-weight-bold">
                                                <input class="form-check-input" type="checkbox"
                                                       v-model="realEstate.displayReport"
                                                       @change="showReport()"
                                                       v-bind:disabled="!hasPermission('REAL_ESTATE_DISPLAY_REPORT')"
                                                >
                                                <span class="form-check-sign"></span>
                                                {{$t("report.field.showReport")}}
                                            </label>
                                        </div>
                                    </div>
                                </b-collapse>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="section-header font-weight-bold" style="cursor: pointer;">
                                        <div block v-b-toggle.new-comparison v-tooltip="'Янги қиёсий ёндашув маълумотларини куриш'">
                                            <h4>
                                                <i class="fa fa-arrow-down"></i>
                                                {{$t("realEstate.approach.comparative")}}
                                                <b class="ml-4" v-if="realEstate.approachComparative">
                                                    <span v-if="isApproachComparative">{{realEstate.newComparison.calculatedTotalPrice | currency('', 2, { thousandsSeparator: ' ' })}} сўм</span>
                                                </b>
                                                <b v-else class="red">
                                                    <span v-if="realEstate.newComparison && realEstate.newComparison.message">{{realEstate.newComparison.message}}</span>
                                                    (воз кечилди)
                                                </b>
                                            </h4>
                                        </div>
                                    </div>
                                    <b-collapse id="new-comparison" accordion="evl-accordion" role="tabpanel">
                                        <NewRealEstateComparison :realEstate="realEstate" />
                                    </b-collapse>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="section-header font-weight-bold" style="cursor: pointer;">
                                        <div block v-b-toggle.income v-tooltip="'Даромад ёндашув маълумотларини куриш'">
                                            <h4>
                                                <i class="fa fa-arrow-down"></i>
                                                {{$t("realEstate.approach.income")}}
                                                <b class="ml-4" v-if="realEstate.approachIncome">
                                                    <span v-if="subBuildingIncomeTotal(realEstate.comparisonNewIncome) > 0">{{ subBuildingIncomeTotal(realEstate.comparisonNewIncome) | currency('', 2, { thousandsSeparator: ' ' })}} сўм</span>
                                                </b>
                                                <b v-else class="red">(воз кечилди)</b>
                                            </h4>
                                        </div>
                                    </div>
                                    <b-collapse id="income" accordion="evl-accordion" role="tabpanel" v-model="incomeVisible">
                                        <div class="row">
                                            <div class="col-12">
                                                <NewRealEstateIncomeView
                                                        :realEstate="realEstate"
                                                        :owner="realEstate.owner"
                                                        :approachIncome="realEstate.approachIncome"
                                                ></NewRealEstateIncomeView>
                                            </div>
                                        </div>
                                    </b-collapse>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="section-header font-weight-bold" style="cursor: pointer;">
                                        <div block v-b-toggle.coordination v-tooltip="'Мувофиқлаштириш маълумотларини куриш'">
                                            <h4>
                                                <i class="fa fa-arrow-down"></i>
                                                Мувофиқлаштириш
                                                <b class="ml-4" v-if="realEstate.evlTotal && realEstate.evlTotal > 0">
                                                    <span>{{realEstate.evlTotal | currency('', 2, { thousandsSeparator: ' ' })}} сўм</span>
                                                </b>
                                            </h4>
                                        </div>
                                    </div>
                                    <b-collapse id="coordination" accordion="evl-accordion" role="tabpanel">
                                        <NewRealEstateCoordinationView></NewRealEstateCoordinationView>
                                    </b-collapse>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="realEstate.id && realEstate.id > 0 && !isPageLoadInit">
                            <div class="col-12">
                                <div class="section-header">
                                    <h4 class="pull-left">
                                        {{$t("realEstate.field.buildingsToEvaluate")}}
                                    </h4>
                                    <button class="all-btn add-btn pull-right" @click="addBuilding" v-if="canSave">
                                        {{$t("realEstate.field.addBuilding")}}
                                    </button>
                                </div>
                                <section v-for="(building, index) in realEstate.buildings" :key="building.id">
                                    <div class="row">
                                        <div class="col-12" v-if="hasPermission('NEW_REAL_ESTATE_BUILDING_DELETE') && canSave">
                                            <button type="button"
                                                    v-tooltip="'Бинони ўчириш'"
                                                    class="all-btn delete-btn float-right mr-3"
                                                    @click="showDeleteBuildingDialog(building, index)"
                                                    >
                                                <i class="fa fa-trash-o"></i>
                                            </button>
                                        </div>
                                        <div class="col-12">
                                            <NewRealEstateBuildingEdit
                                                    :asIncomeValid="realEstate.approachIncome"
                                                    :buildingId="building.id"
                                                    :index="index"
                                                    :ref="`childBuilding-${index}`"
                                                    :isRemoveFile="canRemoveFile"
                                                    :isEditableFile="canSave"
                                            />
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                        <div class="row mt-5">
                            <div class="col-12 btns-box">
                                <button class="all-btn delete-btn" @click="cancel" :disabled="processing">
                                    {{$t("action.cancel")}}
                                </button>
                                <button class="all-btn add-btn" @click="save" :disabled="processing"
                                        v-if="canSave">{{$t("action.save")}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect';
    import {numericTypes} from '@/shared/constants/mask'
    import RealEstateDropZone from '@/views/real-estate/RealEstateDropZone'
    import PreviewDropZone from '@/views/real-estate/PreviewDropZone'
    import initFilterModel from '@/shared/filter';
    import {required, requiredUnless, minValue, minLength} from 'vuelidate/lib/validators';
    import RealEstateLocationMap from '@/views/e-appraisal/RealEstateLocationMap'
    import NewRealEstateIncomeView from '@/views/real-estate/new/NewRealEstateIncomeView'
    import {BCollapse} from 'bootstrap-vue/es/components/collapse/collapse';
    import { VBToggle } from 'bootstrap-vue/es/directives/toggle/toggle'
    import NewRealEstateBuildingEdit from "@/views/real-estate/new/NewRealEstateBuildingEdit";
    import NewRealEstateCoordinationView from '@/views/real-estate/new/NewRealEstateCoordinationView';
    import StepProgress from '@/views/real-estate/new/NewRealEstateStepProgress'
    import {TheMask} from 'vue-the-mask';
    import NewRealEstateComparison from '@/views/real-estate/new/NewRealEstateComparison'
    import AdvancedFilter from '@/shared/filters/advancedFilter';
    import COMPARISON_REFERENCES from '@/shared/constants/realEstateComparison';
    import {cadastreNumber} from "@/shared/validator-helpers";
    import CadastreInput from "@/components/CadastreInput.vue";

    export default {
        name: "NewRealEstateOfAssetEdit",
        components: {
          CadastreInput,
            NewRealEstateBuildingEdit,
            Treeselect,
            RealEstateDropZone,
            PreviewDropZone,
            RealEstateLocationMap,
            BCollapse,
            NewRealEstateCoordinationView,
            StepProgress,
            TheMask,
            NewRealEstateComparison,
            NewRealEstateIncomeView
        },
        directives: {
            'b-toggle': VBToggle
        },
        data() {
            return {
                processing: false,
                isDocQrLoading: false,
                isDocLoading: false,
                isPdfLoading: false,
                isPdfQrLoading: false,
                isCDocLoading: false,
                isCPdfLoading: false,
                isCDocQrLoading: false,
                isCPdfQrLoading: false,
                loadCadastreDoc: false,
                numericTypes: numericTypes,
                ownerFilter: initFilterModel(),
                customerFilter: initFilterModel(),
                cadastreSectionFilter: initFilterModel(),
                filter: initFilterModel(),
                filterMicroRegion: new AdvancedFilter(),
                filterBuildingType: new AdvancedFilter(),
                show: false,
                realEstate: {
                    id: null,
                    assetItemId: ((this.$route.params.hasOwnProperty('assetItemId') && this.$route.params.assetItemId) ? this.$route.params.assetItemId : null),
                    owner: null,
                    approachCost: true,
                    approachIncome: true,
                    approachComparative: true,
                    category: 'Notorious',
                    evlGoalType: 'Predge',
                    name: '',
                    cadastreDocNumber: '',
                    cadastreSections: [],

                    address: '',
                    province: {},
                    region: {},
                    mibRegion: null,

                    evlGroundArea: 0,
                    evlBuildingWidthArea: 0,
                    evlUsefulField: 0,
                    prepayment: 0,

                    employee: {},

                    landComparisonEnabled: false,
                    landCapitalizationEnabled: false,
                    landLeaseEnabled: false,
                    landOwnerEnabled: false,

                    buildings: [],
                    payments: [],

                    balance: [],// баланс
                    cadastre: [],// кадастр хужжати
                    applicationForm: [],// ариза
                    buildingPhotos: [],// бино расмлари
                    privatizationLetter: [],// Кумитанинг бахолаш тугрисида хати
                    privatizationCommissionOrder: [],// Хусусийлаштириш комиссиясининг буйрук ва протоллари
                    ownershipCertificate: [],// Эгалик хукукинитасдикловчи гувохнома
                    checkPaymentFiles: [],// to'lov haqidagi hujjatlar
                    status: 'Pending',

                    displayReport: false,
                    evaluatorIdea: '',

                    landCapitalization: {
                        financingRate: 0,
                        taxPerHectare: 0,
                        calculatedTotalPrice: 0
                    },
                    reasonDesc: '',
                    approachRegression: false,
                    sectionId: null,
                    contractAmountByAgreement: null,
                    contractAmountByAgreementDescription: null,
                    lightConstructiveElement: false,
                    version: 'V2',
                    buildingType: '',
                    microRegionId: null,
                    repairCondition: '',
                    wall: '',
                    builtYear: null,
                    floor: 1,
                    storey: 1,
                    newComparison: {},
                    evlTotal: null,
                    cadastreData: null,
                    wizardSection: 0,
                    financingRate: 0,
                    buildingCondition: false,
                    cadastreBalance: 0,
                    evaluationRespectiveType: "OTHER",
                    specialComfort: null,
                    constructionCompletion: 100,
                    architecturalStyle: null,
                    tenderContractDate: null,
                    tenderContractNumber: null,
                    separateBuilding: false,
                    photos: [],
                    fixByIndex: false,
                    transportPlace: null,
                    evlValueType: 'Market'
                },
                provinces: [],
                regions: [],
                cadastreSections: [],
                financingRate: 0,
                taxPerHectare: 0,
                buildingSections: [],
                buildingTypes: [],
                rowIndex: 0,
                uyJoyProvinces: [],
                microRegions: [],
                buildingType: {},
                repairConditions: [],
                repairCondition: null,
                walls: [],
                wall: null,
                maxMadeYear: new Date().getFullYear(),
                minMadeYear: new Date(0).getFullYear(),
                purposeRentingAreas: [],
                newComparisonMsg: '',
                cadastreDocLength: 28,
                incomeVisible: false,
                realEstateVisible: false,
                evaluationRespectiveTypes: [],
                specialComfort: null,
                specialComforts: [],
                architecturalStyle: null,
                architecturalStyles: [],
                coordination: null,
                cadastreBuildingFieldReferences: {},
                communications: [],
                assetItem: {},
                sectionFields: {
                    fields: ["basement_building_type", "housing_type", "repair", "height", "height_inner", "foundation", "wall", "house_cover", "house_top", "floor_type", "window_and_doors", "electrical_devices", "non_market_type"]
                },
                cadastreBuildingFields: [],
                isPageLoadInit: false,
                status: null,
                ref: {
                    ...COMPARISON_REFERENCES
                },
                minValueUsefulArea: 0.01
            }
        },
        validations() {
            return {
                realEstate: {
                    approach: {
                        required: requiredUnless(() => {
                            return !(!(this.realEstate.approachCost || this.realEstate.approachComparative || this.realEstate.approachIncome || this.realEstate.approachRegression));
                        })
                    },
                    name: {
                        required: required
                    },
                    cadastreDocNumber: {
                        required: required,
                        cadastreNumber: cadastreNumber
                    },
                    sections: {
                        required: requiredUnless( () => {
                            return !(this.isSections);
                        })
                    },
                    address: {
                        required: required
                    },
                    evlBuildingWidthArea: {
                        required: required,
                        minValue: minValue(0.01)
                    },
                    evlUsefulField: {
                        required: required,
                        minValue: minValue(this.minValueUsefulArea)
                    },
                    cadastre: {
                        required: required,
                        minLength: minLength(1)
                    },
                    privatizationLetter: {
                        required: requiredUnless(() => {
                            return !(this.isOwnerTypeLegal && this.isPrivatizationSimple);
                        }),
                        minLength: minLength(1)
                    },
                    privatizationCommissionOrder: {
                        required: requiredUnless(() => {
                            return !(this.isOwnerTypeLegal && this.isPrivatizationSimple);
                        }),
                        minLength: minLength(1)
                    },
                    ownershipCertificate: {
                        required: requiredUnless(() => {
                            return !(this.isOwnerTypeLegal && this.isPrivatizationSimple);
                        }),
                        minLength: minLength(1)
                    },
                    storey: {
                        required: required,
                        minValue: minValue(1)
                    },
                    floor: {
                        required: requiredUnless(() => {
                            return !!(this.isSeparateBuilding)
                        })
                    },
                    builtYear: {
                        required: required,
                        minValue: minValue(1)
                    },
                    cadastreBalance: {
                        required: requiredUnless(() => {
                            return !(this.isApproachIncome);
                        })
                    },
                    evaluationRespectiveType: {
                        required: required
                    },
                    microRegionId: {
                        required: requiredUnless(()=> {
                            return !(this.microRegions && this.microRegions.length > 0)
                        })
                    },
                    constructionCompletion: {
                        required: required,
                        minValue: minValue(0.01)
                    },
                    evlValueType: {
                      required: required
                    }
                },
                buildingType: {
                    code: {
                        required: required
                    }
                },
                repairCondition: {
                    code: {
                        required: required
                    }
                },
                wall: {
                    code: {
                        required: required
                    }
                },
                specialComfort: {
                   code: {
                       required: required
                   }
                },
                architecturalStyle: {
                    code: {
                        required: required
                    }
                },
                cadastreBuildingFields: {
                    $each: {
                        value2: {
                            required: requiredUnless(vm => {
                                return !(this.hasSectionField(vm.code) && this.hasBasementField(vm.code))
                            })
                        }
                    }
                },
                usefulAreaValid: {
                    required: requiredUnless(() => {
                        return !!this.isUsefulAreaValidation
                    })
                }
            };
        },
        computed: {
            isOwnerTypePhysical() {
                return !!(this.realEstate.owner && this.realEstate.owner.type && this.realEstate.owner.type === 'Physical');
            },
            isOwnerTypeLegal() {
                return !!(this.realEstate.owner && this.realEstate.owner.type && this.realEstate.owner.type === 'Legal');
            },
            isOrgTypeMib() {
                return !!(this.realEstate.owner && this.realEstate.owner.organizationType && this.realEstate.owner.organizationType === 'BUREAU_OF_COMPULSORY_EXECUTION');
            },
            isGoalTypeCommon() {
                return this.isGoalType(this.goalTypesCommon);
            },
            isPrivatizationSimple() {
                return this.isGoalType(['Privatization']);
            },
            isPrivatizationZero() {
                return this.isGoalType(['PrivatizationZero']);
            },
            canSave() {
                return (this.assetItem.parentStatus === 'Pending' || this.assetItem.parentStatus === 'AssignedToEvaluator'
                    || this.assetItem.parentStatus === 'NotFullyEvaluated' ||  this.isSentToComplement);
            },
            canEvaluate() {
                let hasBuildingCalculated = false;
                if (this.realEstate.status === 'NotFullyEvaluated' && this.hasPermission('REAL_ESTATE_EVALUATE')) {
                    this.realEstate.buildings.forEach((building) => {
                        if (building.calculated && building.calculated.price && building.calculated.price.expense && building.calculated.price.expense > 0)
                        {
                            hasBuildingCalculated = true;
                        }
                    });
                    if ((this.realEstate.newComparison && this.realEstate.newComparison.totalPrice && this.realEstate.newComparison.totalPrice > 0) ||
                        (this.realEstate.newIncome && this.realEstate.newIncome.calculated && this.realEstate.newIncome.calculated.total > 0)) {
                        hasBuildingCalculated = true;
                    }
                }
                return hasBuildingCalculated;
            },
            canConfirm() {
                return this.realEstate.status === 'Evaluated' && this.hasPermission('REAL_ESTATE_CONFIRM') && (this.realEstate.appraiserReportEsp || !this.realEstate.hasEsp);
            },
            canReEvaluate() {
                return (this.realEstate.status === 'Evaluated' || this.realEstate.status === 'Confirmed') && this.hasPermission('REAL_ESTATE_REEVALUATE');
            },
            checkPaymentLbl() {
                return this.isOrgTypeMib ? "realEstate.field.checkPaymentFilesMib" : "realEstate.field.checkPaymentFiles";
            },
            calculated() {

                let landTaxAmount = 0;
                let financingRate = 0;
                let taxPerHectare = 0;
                let calculatedTotalLandPrice = 0;

                const areaInHectare = this.realEstate.evlGroundArea * 0.0001;

                if (this.taxPerHectare > 0) {
                    taxPerHectare = this.taxPerHectare;
                    landTaxAmount = taxPerHectare * areaInHectare;
                }
                if (this.financingRate > 0) {
                    financingRate = this.financingRate;
                    calculatedTotalLandPrice = landTaxAmount / financingRate * 100;
                }
                return {
                    financingRate: financingRate,
                    taxPerHectare: taxPerHectare,
                    areaInHectare: areaInHectare,
                    landTaxAmount: landTaxAmount,
                    calculatedTotalLandPrice: calculatedTotalLandPrice
                }
            },
            showReportButton() {
                return (this.realEstate.status === 'Evaluated' || this.realEstate.status === 'Confirmed') && this.realEstate.id && this.realEstate.id > 0;
            },
            isSections() {
                return !(this.realEstate.cadastreSections && this.realEstate.cadastreSections.length > 0) && this.realEstate.approachCost && this.realEstate.status != 'SentToComplement'
            },
            isApproachComparative() {
                return this.realEstate.newComparison && this.realEstate.newComparison.calculatedTotalPrice
            },
            isApproachIncome() {
                return this.realEstate.approachIncome;
            },
            isSeparateBuilding() {
                return (this.buildingType && this.buildingType.code === 'RESIDENTIAL_INDIVIDUAL') || (this.realEstate.separateBuilding)
            },
            isNoChangeIncome() {
                return this.repairCondition && this.repairCondition.code === 'wreckage' && this.realEstate.evlGoalType !== 'Losses'
            },
            totalBuildingIncome() {
                return this.realEstate.buildings
                    .map(building => this.subBuildingIncomeTotal(building.newIncome))
                    .reduce((a, b) => a + b, 0)
            },
            totalIncomeLandCost() {
               return this.realEstate.buildings.map(building => {
                   if (building.newIncome && building.newIncome.calculated) {
                       return building.newIncome.calculated.propertyTaxAmount + building.newIncome.calculated.landTaxAmount;
                   }
               })[0];
            },
            isPaid() {
                return this.realEstate.paidAmount > 0;
            },
            isOnlineAndApi() {
                return this.realEstate.source === 'ONLINE' || this.realEstate.source === 'API_MIB'
                        || this.realEstate.source === 'API' || this.realEstate.source === 'API_BANK'
            },
            isTenders() {
                return this.realEstate.evaluationRespectiveType === 'TENDERS';
            },
            isCollapseVisibleDocs() {
                if (this.isOwnerTypePhysical) {
                    return (this.$v.realEstate.cadastre.$error)
                } else {
                    return (this.$v.realEstate.cadastre.$error)
                }
            },
            isBuildingMultiStorey() {
                return this.buildingType.code === 'RESIDENTIAL_MULTI_STOREY'
            },
            canRemoveFile() {
                return this.status && this.status!=='Evaluated' && this.status!=='Confirmed' && this.status!=='Rejected' && this.hasPermission('REAL_ESTATE_IMAGE_DELETE');
            },
            isUsefulAreaValidation() {

                let area = this.realEstate.evlGroundArea ? this.realEstate.evlGroundArea : 0;
                let basementBuildingType = '';
                let usefulArea = this.realEstate.evlUsefulField ? this.realEstate.evlUsefulField : 0;
                let storey = this.realEstate.storey;

                if (this.realEstate.data && this.realEstate.data.values) {
                    const basement = this.realEstate.data.values['basement_building_type'];
                    if (basement) {
                        basementBuildingType = basement.code;
                    }
                }

                if (this.isBuildingMultiStorey) {
                    return true;
                } else if (basementBuildingType === 'WITH_BASEMENT') {
                    return (storey + 1) * area >= usefulArea;
                } else
                    return storey * area >= usefulArea;
            },
            isBasementFloor() {
                return this.realEstate.floor === -1;
            },
            isSentToComplement() {
                return !!(this.assetItem.parentStatus === 'SentToComplement')
            }
        },
        methods: {
            init() {
                const vm = this;
                const id = vm.$route.params.id;
                let category = '';
                if (vm.$route && vm.$route.meta && vm.$route.meta.category && vm.$route.meta.category.length > 0) {
                    category = vm.$route.meta.category;
                }
                const promises = [
                    vm.$http.get('admin/new-real-estate/init/' + ((category && category.length > 0) ? category : 'na') + '/' + ((id && id > 0) ? id : '0')),
                ];

                if (id && id > 0) {
                    promises.push(this.$http.get('admin/new-real-estate/' + id));
                } else {
                    vm.realEstate.category = category;
                }

                Promise.all(promises).then(function (values) {
                    const initData = values[0].data;
                    // vm.provinces = initData.provinces;
                    vm.cadastreSections = initData.cadastreSections.map((item) => {
                        item.label = item.name;
                        return item;
                    });

                    // if (initData.uyJoyApiRegions && initData.uyJoyApiRegions.length > 0) {
                    //     vm.uyJoyProvinces = initData.uyJoyApiRegions;
                    // }
                    vm.buildingSections = initData.buildingSections;

                    vm.sectionFields.fields.forEach((field) => {
                        const buildingField = initData.fields.filter((f) => f.code === field);
                        vm.cadastreBuildingFields.push(buildingField[0])
                    });
                    vm.cadastreBuildingFieldReferences = initData.references;

                    if (values.length >= 2) {
                        const editData = values[1].data;

                        if (editData.data && editData.data.values) {
                            vm.cadastreBuildingFields.forEach((field) => {
                                if (field.code && editData.data.values.hasOwnProperty(field.code)) {
                                    const fieldValue = editData.data.values[field.code];
                                    if (fieldValue) {
                                        if (field.type === 'COMBOBOX' || field.type === 'LISTBOX') {
                                            if (fieldValue.id && fieldValue.id > 0) {
                                                field.value2 = fieldValue.id;
                                                field.selected2 = vm.getReferenceById(field.reference.code, fieldValue.id);
                                            }
                                        } else if (field.type === 'MULTISELECT') {
                                            if (fieldValue) {
                                                field.selected2 = [];
                                                if (fieldValue.length > 0) {
                                                    fieldValue.forEach((ref) => {
                                                        field.selected2.push(ref.id);
                                                    });
                                                } else if (fieldValue.hasOwnProperty('id') && fieldValue.id && fieldValue.id > 0) {
                                                    field.selected2.push(fieldValue.id);
                                                }
                                                field.value2 = field.selected2;
                                            }
                                        } else {
                                            field.value2 = fieldValue;
                                        }
                                    }
                                }
                            });
                        }

                        if (!editData.wizardSection) {
                            editData.wizardSection = 0
                        }
                        vm.realEstate = editData;
                        if (editData.landCapitalization && editData.landCapitalization.financingRate > 0 && editData.landCapitalization.taxPerHectare > 0) {
                            vm.initLandCapitalizationData(editData.landCapitalization)
                        }
                        if (editData.financingRate) {
                            vm.financingRate = editData.financingRate;
                        }

                        if (editData.buildingType) {
                            vm.initBuildingType();
                        }
                        if (editData.repairCondition) {
                            vm.initRepair();
                        }
                        if (editData.wall) {
                            vm.initConstructiveElement();
                        }

                        if (editData.newIncome) {
                            vm.newIncome = editData.newIncome
                        }
                        if (vm.realEstate.cadastreData && editData.wizardSection === 0) {
                            vm.calculatedCadastreData(vm.realEstate.cadastreData);
                        }
                        if (editData.specialComfort) {
                            vm.initSpecialComfort()
                        }

                        if (editData.architecturalStyle) {
                            vm.initArchitecturalStyle()
                        }

                        vm.onChangeConstructionCompletion()
                    }

                    vm.isPageLoadInit = true;
                    if (vm.realEstate.assetItemId && vm.realEstate.assetItemId != null) {
                        vm.$http.get('asset/item/' + vm.realEstate.assetItemId).then(function (assetData) {
                            if (assetData.status == 200) {
                                vm.assetItem = assetData.data;
                                vm.realEstate.province = assetData.data.province;
                                vm.realEstate.region = assetData.data.region;
                                vm.status = assetData.data.parentStatus;
                                vm.realEstate.status = assetData.data.parentStatus
                                vm.onRegionChange();
                            }
                            vm.isPageLoadInit = false;
                        });
                    }
                });
            },
            addBuilding() {
                let item = {};
                this.realEstate.buildings.push(item);
            },
            cancel() {
                this.$router.push('/asset/item/edit/' + this.realEstate.assetItemId);
            },
            headerAction(action) {
                if (this.canSave) {
                    this.saveAndGo(action)
                } else if ('coordination' === action) {
                    this.$router.push('/new-real-estate/coordination/' + this.realEstate.id + "/" + true);
                } else if ('land' === action) {
                    this.$router.push('/asset/new-real-estate/land/' + this.realEstate.id);
                } else if ('new_land' === action) {
                    this.$router.push(`/asset/new-real-estate/new-land/${this.realEstate.id}`)
                }
            },
           save() {
                this.saveAndGo('close');
            },
           saveAndGo(action) {
                let isValid = true;
                this.realEstateVisible = false;

                this.$v.$touch();
                this.$v.usefulAreaValid.$touch();

                if (this.$v.$invalid || this.$v.usefulAreaValid.$invalid) {
                    this.realEstateVisible = true;
                    isValid = false
                }

                if ((this.realEstate.wizardSection === 1 || this.realEstate.wizardSection === 2) && (action !== 'new_land')) {
                    if (this.realEstate.approachCost) {
                        let properties = Object.keys(this.$refs).reverse();
                        properties.forEach(el => {
                            if (el.includes('childBuilding-')) {
                                const bv = this.$refs[el][0].$v;
                                bv.$touch();
                                if (bv.$invalid) {
                                    isValid = false;
                                    this.$refs[el][0].isAddValueCollapse = true;
                                }
                                if (isValid) {
                                    this.$refs[el][0].save();
                                }
                            }
                        });
                    }
                    if (isValid) {
                        this.realEstate.wizardSection = 2;
                    }
                } else if (isValid) {
                    this.realEstate.wizardSection = 1;
                }

                if (!(isValid || action === 'new_land')) {
                    return;
                }

                if (this.realEstate.landCapitalizationEnabled) {
                    this.realEstate.landCapitalization = {
                        financingRate: this.calculated.financingRate,
                        taxPerHectare: this.calculated.taxPerHectare,
                        calculatedTotalPrice: this.calculated.calculatedTotalLandPrice
                    };
                }

                if (this.repairCondition) {
                    this.realEstate.repairCondition = this.repairCondition.code;
                }

                if (this.wall) {
                    this.realEstate.wall = this.wall.code;
                }
                this.realEstate.buildingType = this.buildingType.code;
                this.realEstate.financingRate = this.financingRate;

                if (!this.realEstate.floor && this.isSeparateBuilding) {
                    this.realEstate.floor = 1;
                }

                if (this.specialComfort) {
                    this.realEstate.specialComfort = this.specialComfort.code
                }

                if (this.architecturalStyle) {
                    this.realEstate.architecturalStyle = this.architecturalStyle.code
                }
                this.$http.post('admin/new-real-estate', this.realEstate)
                    .then(res => {
                        this.processing = false;
                        if (res.data.status === "ERROR") {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: res.data.message,
                                type: 'warning'
                            });
                            return;
                        }

                        if ('land' === action) {
                            this.$router.push('/asset/new-real-estate/land/' + res.data.data.id);
                        } else if ('coordination' === action) {
                            this.$router.push('/asset/new-real-estate/coordination/' + res.data.data.id + '/' + false);
                        } else if ('new_land' === action) {
                            this.$router.push(`/asset/new-real-estate/new-land/${this.realEstate.id}`)
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('messages.realEstate.success'),
                                type: 'success'
                            });
                            this.$router.push('/asset/item/edit/' + this.realEstate.assetItemId);
                        }

                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.realEstate.error'),
                            type: 'error'
                        });
                        this.processing = false;
                    });
            },
            showDeleteBuildingDialog(building, index) {
                this.$swal({
                    title: this.$t('messages.common.warning'),
                    text: this.$t('messages.building.deleteConfirm'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#dd3333',
                    confirmButtonText: 'Ўчириш',
                    cancelButtonText: 'Бекор қилиш'
                    // cancelButtonColor: '#dd3333'
                }).then((result) => {
                    if (result.value) {
                        this.$http.delete('new-real-estate/building/' + building.id)
                            .then((res) => {
                                if (res && res.data && res.data.status === 'SUCCESS') {
                                    this.$swal({
                                        title: this.$t('messages.common.success'),
                                        text: this.$t('messages.building.deleteSuccess'),
                                        type: 'success'
                                    });
                                    this.realEstate.buildings.splice(index, 1);
                                } else {
                                    this.$swal({
                                        title: this.$t('messages.common.warning'),
                                        text: res.data.message,
                                        type: 'warning'
                                    });
                                }
                                this.processing = false;
                            }, () => {
                                this.$swal({
                                    title: this.$t('messages.common.error'),
                                    text: this.$t('messages.building.deleteError'),
                                    type: 'error'
                                });
                                this.processing = false;
                            });
                    }
                });
            },
            isGoalType(goalTypeCodes) {
                return !!(this.realEstate.evlGoalType && goalTypeCodes && goalTypeCodes.indexOf(this.realEstate.evlGoalType) >= 0);
            },
            initProvinceRegions() {
                let regions = [];
                if (this.assetItem.province && this.assetItem.province.id && this.assetItem.province.id > 0 && this.provinces && this.provinces.length > 0) {
                    this.provinces.forEach((province) => {
                        if (province.id === this.assetItem.province.id && province.regions && province.regions.length > 0) {
                            regions = province.regions;
                        }
                    });
                }
                this.regions = regions;
            },
            onProvinceChange() {
                this.initProvinceRegions();
                this.realEstate.region = {};
                this.realEstate.microRegion = {};
                this.microRegions = [];
                if (this.assetItem.province.id > 0) {
                    this.initLandCapitalizationProvinceChangeData();
                }
            },
            isEvlApproachConfirm() {
                return (this.realEstate.approachCost && (this.realEstate.approachComparative || this.realEstate.approachIncome));
            },
            showReport: function () {
                this.$http.post('admin/real-estate/show-report/' + this.realEstate.id + '/' + this.realEstate.displayReport)
                    .then(res => {
                        if (res && res.data && res.data.status === 'SUCCESS') {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('messages.realEstate.showReportSuccess'),
                                type: 'success'
                            });
                            this.realEstate.status = status;
                        } else if (res && res.data && res.data.status === 'FAIL') {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('messages.realEstate.showCancelReportSuccess'),
                                type: 'success'
                            });
                        }
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.realEstate.showReportError'),
                            type: 'error'
                        });
                    });
            },
            handleChangeLand: function (e) {
                const name = e.target.name;
                if (this.realEstate[name]) {
                    Object.keys(this.realEstate).map((key) => {
                        if (key != name) {
                            if (key === 'landComparisonEnabled' || key === 'landCapitalizationEnabled' || key === 'landLeaseEnabled') {
                                this.realEstate[key] = false;
                            }
                        }
                    })
                }
                if (this.realEstate.landCapitalizationEnabled) {
                    this.initLandCapitalizationRegionChangeData();
                }
            },
            onRegionChange() {
                if (this.realEstate.region.id > 0) {
                    this.initLandCapitalizationRegionChangeData();
                    this.onMicroRegionFocus();
                }
            },
            onMicroRegionFocus() {
                this.microRegions = [];
                this.filterMicroRegion.region = (this.realEstate.region && this.realEstate.region.id) ? this.realEstate.region.id : 0;
                this.$http.post('/uy-joy-api/micro-regions', this.filterMicroRegion.asQuery())
                    .then(res => {
                        this.microRegions = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            // onMicroRegionsChange() {
            //     let provinces = [];
            //     let realEstateRegions = [];
            //     this.microRegions = [];
            //     provinces = this.provinces.filter((province) => province.id === this.assetItem.province.id);
            //     const regions =  this.getUyJoyRegions(this.uyJoyProvinces,provinces[0].code);
            //     realEstateRegions = this.regions.filter((region) => region.id === this.assetItem.region.id);
            //     let microRegions = this.getUyJoyRegions(regions,realEstateRegions[0].region.code);
            //     if (microRegions && microRegions.length > 0) {
            //         this.microRegions = microRegions.map((region) =>({id: region.id,name: region.label}));
            //     }
            // },
            //
            // getUyJoyRegions(regions,provinceCode) {
            //     const uyJoyProvinces = regions.filter((province) => province.code === provinceCode);
            //     return uyJoyProvinces.length > 0 ? uyJoyProvinces[0].children : [];
            // },

            initLandCapitalizationProvinceChangeData() {
                const vm = this;
                this.$http.get('admin/new-real-estate/land-capitalization/province/' + this.assetItem.province.id)
                    .then(res => {
                        const data = res.data;
                        vm.initLandCapitalizationData(data)
                    }, err => {
                        console.log(err);
                    });
            },
            initLandCapitalizationRegionChangeData() {
                const vm = this;
                this.$http.get('admin/new-real-estate/land-capitalization/region/' + this.assetItem.region.id)
                    .then(res => {
                        const data = res.data;
                        vm.initLandCapitalizationData(data)
                    }, err => {
                        console.log(err);
                    });
            },
            initLandCapitalizationData(data) {
                this.financingRate = data.financingRate;
                this.taxPerHectare = data.taxPerHectare;
            },
            calculateApproachTotal(building) {
                let approachTotalPrice = 0;
                if (building.calculated && building.calculated.price && building.calculated.price.expense && this.realEstate.approachCost) {
                    approachTotalPrice = approachTotalPrice + building.calculated.price.expense;
                }
                if (building.comparison && building.comparison.calculatedTotalPrice && this.realEstate.approachComparative) {
                    approachTotalPrice = approachTotalPrice + building.comparison.calculatedTotalPrice;
                }
                if (building.comparisonIncome && building.comparisonIncome.calculated && building.comparisonIncome.calculated.total && this.realEstate.approachIncome) {
                    approachTotalPrice = approachTotalPrice + building.comparisonIncome.calculated.total;
                }
                if (building.comparisonRegression && building.comparisonRegression.totalPrice && this.realEstate.approachRegression) {
                    approachTotalPrice = approachTotalPrice + building.comparisonRegression.totalPrice;
                }
                return approachTotalPrice;
            },
            onBuildingFocus() {
                this.buildingTypes = [];
                this.filterBuildingType.cadastreType = this.realEstate.category
                this.filterBuildingType.onlyParentLookUp = true

                this.$http.post('building-type/list', this.filterBuildingType)
                    .then(res => {
                        if (res.data !== "" && res.data.data.length > 0) {
                            this.buildingTypes = res.data.data;
                        }
                    }, err => {
                        console.log(err);
                    });
            },
            onRepairFocus() {
               this.repairConditions = [];
               this.$http.get('uy-joy-api/repair-conditions')
                   .then(res => {
                       this.repairConditions = res.data;
                   },err => {
                       console.log(err)
                   })
            },
            onRepairChange() {
                if (this.repairCondition && this.repairCondition.code === 'wreckage') {
                    this.realEstate.approachIncome = false;
                }
            },
            onChangeBuildingType() {
                if (this.buildingType && this.buildingType.id > 0) {
                    this.purposeRentingAreas = [];
                    this.$http.get('rental-rates/purposes-renting-areas/tree-lookup/' + this.buildingType.code)
                        .then(res => {
                            this.purposeRentingAreas = res.data;
                        }, err => {
                            console.log(err);
                        });
                }
            },
            initBuildingType() {
                const vm = this;
                this.filterBuildingType.cadastreType = this.realEstate.category
                this.filterBuildingType.onlyParentLookUp = true

                this.$http.post('building-type/list', this.filterBuildingType)
                    .then(res => {
                        if (res.data !== "" && res.data.data.length > 0) {
                            vm.buildingTypes = res.data.data;
                            const buildingTypes = vm.buildingTypes.filter(b => b.code === vm.realEstate.buildingType);
                            vm.buildingType = buildingTypes[0];
                        }
                    }, err => {
                        console.log(err);
                    });
            },
            initRepair() {
                this.repairConditions = [];
                const vm = this;
                this.$http.get('uy-joy-api/repair-conditions')
                    .then(res => {
                        vm.repairConditions = res.data;
                        const repairConditions = vm.repairConditions.filter(r => r.code === vm.realEstate.repairCondition);
                        vm.repairCondition = repairConditions[0];
                    },err => {
                        console.log(err)
                    })
            },
            onConstructiveElementFocus() {
                const url = this.buildingType ? 'uy-joy-api/wall-types/' + this.buildingType.code : 'uy-joy-api/wall-types';
                this.$http.get(url)
                    .then(res => {
                        this.walls = res.data;
                    }, err => {
                        console.log(err);
                    });
            },
            initConstructiveElement() {
                const vm = this;
                const url = this.buildingType ? 'uy-joy-api/wall-types/' + this.buildingType.code : 'uy-joy-api/wall-types';
                this.$http.get(url)
                    .then(res => {
                        this.walls = res.data;
                        const walls = vm.walls.filter(w => w.code === vm.realEstate.wall);
                        vm.wall = walls[0];
                    }, err => {
                        console.log(err);
                    });
            },
            initSpecialComfort() {
                this.specialComforts = [];
                const vm = this;
                this.$http.get('admin/new-real-estate/special-comports')
                    .then(res => {
                        if (res.data && res.data.length > 0) {
                            vm.specialComforts = res.data;
                            const specialComforts = vm.specialComforts.filter(s =>s.code === vm.realEstate.specialComfort);
                            vm.specialComfort = specialComforts[0]
                        }
                    }, err => {
                        console.log(err);
                    });
            },
            initArchitecturalStyle() {
                this.architecturalStyles = [];
                const vm = this;
                this.$http.get('admin/new-real-estate/architectural-styles')
                    .then(res => {
                        if (res.data && res.data.length > 0) {
                            vm.architecturalStyles = res.data;
                            const architecturalStyle = vm.architecturalStyles.filter(a => a.code === vm.realEstate.architecturalStyle);
                            vm.architecturalStyle = architecturalStyle[0]
                        }
                    },err => {
                        console.log(err)
                    })
            },
            getCheckTextValue(value) {
               return (value.length > 0) ? value: null
            },
            getBuildingMax(arr) {
                return arr.reduce((p,v) => {
                    return (p.PloshadZastroyka > v.PloshadZastroyka ? p:v);
                })
            },
            isItems(items) {
               return items && items.length > 0
            },
            initCadastreApiData() {
                if (this.realEstate.cadastreDocNumber && this.realEstate.wizardSection <= 1) {
                    const data = {
                        cadastreDocNumber: this.realEstate.cadastreDocNumber
                    }
                    this.loadCadastreDoc = true;
                    this.$http.post('/cadaster/data',data)
                        .then(res => {
                            const resData = res.data;
                            if(resData && resData.data) {
                                const result = resData.data;
                                this.realEstate.cadastreData = result;
                                this.calculatedCadastreData(result);
                                this.loadCadastreDoc = false
                            }
                        },(err) => {
                            console.log(err);
                            this.loadCadastreDoc = false
                        })
                }
            },
            calculatedCadastreData(result) {
                if (result.VidSobstvennosti) {
                    if (result.VidSobstvennosti.name === 'Частная') {
                        this.realEstate.evlPropertyType = 'Private';
                    } else if (result.VidSobstvennosti.name === 'Госсобственность') {
                        this.realEstate.evlPropertyType = 'Government'
                    }
                }

                if (result.injunction) {
                    this.realEstate.buildingCondition = result.injunction
                }

                if (result.KadStoimost && result.KadStoimost > 0) {
                    this.realEstate.cadastreBalance = result.KadStoimost;
                }

                let address = '';
                if (this.getCheckTextValue(result.Imya_Maxalya)) {
                    address = result.Imya_Maxalya;
                }
                if (this.getCheckTextValue(result.Imya_Ulitsa)) {
                    if (address.length > 0) {
                        address+=', '
                    }
                    address +=result.Imya_Ulitsa;
                }
                if (this.getCheckTextValue(result.NomerDoma)) {
                    if (address.length > 0) {
                        address+=', '
                    }
                    address += result.NomerDoma;
                }
                if (this.getCheckTextValue(result.NomerKv)){
                    if (address.length > 0) {
                        address+=', '
                    }
                    address+= result.NomerKv;
                }

                this.realEstate.address = address;

                if (result.PloshadZU) {
                    this.realEstate.evlGroundArea = result.PloshadZU;
                }

                if (result.PloshadZastroyka) {
                    this.realEstate.evlBuildingWidthArea = result.PloshadZastroyka;
                }
                if (result.PoleznayaPloshad) {
                    this.realEstate.evlUsefulField = result.PoleznayaPloshad;
                }

                let maxBuilding;
                if (this.isItems(result.items)) {
                    maxBuilding = this.getBuildingMax(result.items);
                }

                if (result.GodPostroyki > 0) {
                    this.realEstate.builtYear = result.GodPostroyki

                } else if (maxBuilding && maxBuilding.GodPostroyki > 0) {
                    this.realEstate.builtYear = maxBuilding.GodPostroyki

                } else if (this.isItems(result.items)) {
                    let item = result.items.filter((item) => item.GodPostroyki > 0);
                    if (item && item.length > 0) {
                        this.realEstate.builtYear = item[0].GodPostroyki
                    }
                }

                if (maxBuilding && maxBuilding.Etajnost > 0) {
                    this.realEstate.storey = maxBuilding.Etajnost;

                } else if (this.isItems(result.items)) {
                    let item = result.items.filter((item) => item.Etajnost > 0);
                    if (item && item.length > 0) {
                        this.realEstate.storey = item.Etajnost;
                    }
                }

                let story = this.realEstate.storey;
                if ( story > 0 && story < 2) {
                    this.realEstate.floor =  story;
                } else if (result.Etaji > 0) {
                    this.realEstate.floor = result.Etaji;
                }
            },
            onChangeStorey(val) {
                if (val > 0 && val < 2) {
                    this.realEstate.floor = val
                }
            },
            subBuildingIncomeTotal(income) {
                if (income && income.calculated && income.calculated.total) {
                    return income.calculated.total;
                }
                return 0;
            },
            getEvaluationRespectiveType() {
                this.$http.get('/evaluationRespectiveType').then(response => {
                    this.evaluationRespectiveTypes = response.data;
                },err => {
                    console.log(err)
                });
            },
            onSpecialComfortFocus() {
                this.specialComforts = [];
                this.$http.get('admin/new-real-estate/special-comports')
                    .then(res => {
                        if (res.data && res.data.length > 0) {
                            this.specialComforts = res.data;
                        }
                    }, err => {
                        console.log(err);
                    });
            },
            onArchitecturalStyleFocus() {
                this.architecturalStyles = [];
                this.$http.get("admin/new-real-estate/architectural-styles")
                    .then(res => {
                        if (res.data && res.data.length > 0) {
                            this.architecturalStyles = res.data;
                        }
                    },err => {
                        console.log(err);
                    });
            },
            getReferenceById(code, id) {
                if (this.cadastreBuildingFieldReferences.hasOwnProperty(code)) {
                    const fieldReferences = this.cadastreBuildingFieldReferences[code];
                    const references = fieldReferences.filter((ref) => {
                        return ref.id === id
                    });
                    return references.length > 0 ? references[0] : null;
                } else {
                    return null;
                }
            },
            multiSelectOptions(options) {
                const items = [];
                if (options && options.length > 0) {
                    options.forEach((option) => {
                        items.push({
                            id: option.id,
                            label: option.name
                        });
                    });
                }
                return items;
            },
            onFieldValueChange(field) {
                if (field) {
                    let fieldValue = {};
                    if (field.type === 'COMBOBOX' || field.type === 'LISTBOX') {
                        if (field.type === 'LISTBOX') {
                            field.selected2 = this.getReferenceById(field.reference.code, field.value2);
                        }
                        if (field.selected2) {
                            fieldValue = {
                                id: field.selected2.id,
                                code: field.selected2.code
                            }
                        }
                        if (field.type === 'COMBOBOX') {
                            field.value2 = fieldValue;
                        }
                    } else if (field.type === 'MULTISELECT') {
                        fieldValue = [];
                        if (field.selected2 && field.selected2.length > 0) {
                            field.selected2.forEach((ref_id) => {
                                const ref = this.getReferenceById(field.reference.code, ref_id);
                                if (ref) {
                                    fieldValue.push({
                                        id: ref.id,
                                        code: ref.code
                                    })
                                }
                            });
                        }
                        field.value2 = fieldValue;
                    } else {
                        fieldValue = field.value2;
                    }

                    if (!this.realEstate.data) {
                        this.realEstate.data = {
                            values: {
                                height: null,
                                height_inner: null,
                                foundation: null,
                                wall: null,
                                house_cover: null,
                                house_top: null,
                                floor_type: null,
                                window_and_doors: null,
                                electrical_devices: null
                            }
                        }
                    }
                    this.realEstate.data.values[field.code] = fieldValue;
                }
            },
            hasSectionField(code) {
                const fields = this.sectionFields.fields.filter((field) => {
                  return field !== 'non_market_type'
                })
                return fields.includes(code)
            },
            onChangeUsefulArea() {
                this.$v.usefulAreaValid.$touch()
                this.onChangeConstructionCompletion()
            },
            hasBasementField(code) {
                if (code === 'basement_building_type') {
                    return !this.isBasementFloor;
                }
                return true;
            },
            onChangeConstructionCompletion() {
              if (this.realEstate.constructionCompletion < 100) {
                this.minValueUsefulArea = 0
              } else {
                this.minValueUsefulArea = 0.01
              }
            }
        },
        created() {
            this.cadastreSectionFilter.page.size = 10000;
            this.filterMicroRegion.pageFilter.size = 10000;
            this.init();
            this.getEvaluationRespectiveType();
        }
    }
</script>

<style scoped>
    .comparison-table th {
        /*vertical-align: top;*/
        border: 1px solid #dee2e6;
        border-collapse: collapse;
        background-color: #E9FAFD;
    }
    .comparison-table td {
        border: 1px solid #dee2e6;
        border-collapse: collapse;
    }
    .comparison-table .percentage {
        margin: auto;
        width: 110px !important;
        display: inline-block;
    }
    .comparison-table .percentage div {
        width: 80px !important;
        float: left;
    }
    .comparison-table .percentage span {
        display: block;
        margin: 7px 5px;
        float: left;
    }
    .comparison-table .section-start td {
        background-color: #F3F3F3;
    }
    .comparison-table .section-start > td:first-child {
        font-weight: bold;
    }
</style>
